import { render } from "./AppBaseSwitchToggle.vue?vue&type=template&id=63b4b205&scoped=true"
import script from "./AppBaseSwitchToggle.vue?vue&type=script&lang=js"
export * from "./AppBaseSwitchToggle.vue?vue&type=script&lang=js"

import "./AppBaseSwitchToggle.vue?vue&type=style&index=0&id=63b4b205&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b4b205"]])

export default __exports__